










































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditResource from "./edit-resource.vue";

class PageResourceRequest extends PageRequest {
  keyword: string;
  classTypeId: number = 2;
  multiTypeName: string = "资源";
  parentId?: number;
  parentName: string = "上级分类";
  categoryId?: number;
  isAudit: boolean = false;
  screenWidth: number = document.body.clientWidth;
}

@Component({ components: { EditResource } })
export default class AuditResources extends AbpBase {
  //filters
  pagerequest: PageResourceRequest = new PageResourceRequest();
  editModalShow: boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];
  selectionIds: any = [];
  categoryId: number = 0;
  dataResource: any = [];
  valueResource: any = [];
  resourceCategoryId?: number = null;

  edit() {
    this.editModalShow = true;
  }
  searchGetpage() {
    this.$store.state.resource.currentPage = 1;
    this.getpage();
  }
  resourceSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.resourceCategoryId = selectedData[selectedData.length - 1].id;
    else this.resourceCategoryId = null;
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.$store.state.resource.currentPage = 1;
    this.getpage();
  }
  changeTypeSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.categoryId = selectedData[selectedData.length - 1].id;
    else this.categoryId = 0;
  }
  handleRefresh() {
    this.loadCascaders();
  }
  get list() {
    return this.$store.state.resource.list;
  }
  get loading() {
    return this.$store.state.resource.loading;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
  }
  pageChange(page: number) {
    this.$store.commit("resource/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("resource/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store
      .dispatch({
        type: "resource/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId }, //资源新闻
      })
      .then((result) => {
        this.data = this.$store.state.resource.cascaders.items;
        this.$store
          .dispatch({
            type: "resource/getTopicCascader", //专题
            data: { classTypeId: 5 },
          })
          .then((result) => {
            this.dataResource =
              this.$store.state.resource.resourceCascaders.items;
            this.getpage();
          });
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "resource/getAllModerated",
      data: this.pagerequest,
    });
    this.$Modal.remove();
  }
  handleSelect(selection, row) {}
  handleSelectionChange(selection) {
    this.selectionIds = [];
    if (selection.length > 0)
      selection.forEach((e) => {
        this.selectionIds.push(e.id);
      });
  }
  handleBatchCommand() {
    if (!this.selectionIds || this.selectionIds.length == 0) {
      this.$Message.warning("请选择至少一条数据");
      return;
    }
    this.$Modal.confirm({
      title: "操作提示",
      content: "<p>确定要执行审核操作吗?</p>",
      loading: true,
      onOk: () => {
        this.doBatchCommand();
      },
    });
  }
  async doBatchCommand() {
    await this.$store.dispatch({
      type: "resource/auditedResource",
      data: {
        resourceIds: this.selectionIds,
        categoryId: this.categoryId,
        resourceCategoryId: this.resourceCategoryId,
      },
    });
    this.getpage();
  }
  get pageSize() {
    return this.$store.state.resource.pageSize;
  }
  get totalCount() {
    return this.$store.state.resource.totalCount;
  }
  get currentPage() {
    return this.$store.state.resource.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  columns = [
    { type: "selection", width: 60, key: "handle" },
    {
      title: "分类",
      width: 110,
      key: "categoryName",
    },
    {
      title: "标题",
      key: "title",
    },
    {
      title: "类型",
      width: 70,
      key: "resourceCategoryName",
    },
    {
      title: "审核",
      width: 70,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isAudit ? "" : "red",
            },
          },
          params.row.isAudit ? "已审" : "待审"
        );
      },
    },
    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/" + params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      width: 180,
      key: "Actions",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.selectionIds.push(params.row.id);
                  await this.$store.dispatch({
                    type: "resource/auditedResource",
                    data: { resourceIds: this.selectionIds },
                  });
                  await this.getpage();
                },
              },
            },
            "审核"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId
                  );
                  this.$store.commit("resource/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.resource.editResource.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，【" + params.row.name + "】吗？"
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "resource/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  columns2 = [
    { type: "selection", width: 60, key: "handle" },

    {
      title: "标题",
      key: "title",
    },
    {
      title: "类型",
      width: 70,
      key: "resourceCategoryName",
    },

    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/inhome/" +
                  params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      width: 180,
      key: "Actions",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.selectionIds.push(params.row.id);
                  await this.$store.dispatch({
                    type: "resource/auditedResource",
                    data: { resourceIds: this.selectionIds },
                  });
                  await this.getpage();
                },
              },
            },
            "审核"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId
                  );
                  this.$store.commit("resource/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.resource.editResource.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，【" + params.row.name + "】吗？"
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "resource/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.$store.state.resource.currentPage = 1;
    this.loadCascaders();
  }
}
